export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    // clipboard-write を試す
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // エラー発生時はexecCommandを試す。なお、cordova-clipboardプラグインも存在するがメンテナンスされていないので利用しない
    try {
      const tmpEl = document.createElement("input");
      document.body.appendChild(tmpEl);
      tmpEl.value = text;
      tmpEl.select();
      const result = document.execCommand("copy");
      document.body.removeChild(tmpEl);
      return result;
    } catch (err2) {
      // どちらも失敗したらfalseを返す
      return false;
    }
  }
};
